import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import type LustrationReportsCreateViewModel from "viewModels/enforcement/lustrationReports/lustrationReportsCreateViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import TimeInput from "controls/timeInput";
import CountrySelect from "views/common/countrySelect";
import LicensePlateInput from "controls/licensePlateInput";
import { subYears } from "date-fns";
import { disabledDaysRange, endOfCzechDay } from "utils/dateUtils";
import DatePickerBox from "controls/datePickerBox";
export interface LustrationReportsFormProps {
  vm: LustrationReportsCreateViewModel;
  children?: React.ReactNode;
}

const LustrationReportsForm = observer((props: LustrationReportsFormProps) => {
  const { vm, children } = props;

  return (
    <>
      <Form.Row>
        <FormGroup className="pr-3 pb-1 pt-1" as={Col} md={6} lg={6} xl={6} target={vm.item} property="countryId">
          <FormLabel>{vm.translateAttribute("countryId")}</FormLabel>
          <CountrySelect menuFixed vm={vm.countrySelectViewModel} placeholder={vm.translateAttribute("countryIdPlaceholder")} />
        </FormGroup>
        <FormGroup className="pl-3 pb-1 pt-1" as={Col} md={6} lg={6} xl={6} target={vm.item} property="licensePlate">
          <FormLabel>{vm.translateAttribute("licensePlate")}</FormLabel>
          <LicensePlateInput placeholder={vm.translateAttribute("licensePlatePlaceholder")} />
        </FormGroup>
      </Form.Row>
      <Form.Row className="pb-6">
        <FormGroup className="pr-3 pb-1 pt-1" as={Col} md={6} lg={6} xl={6} target={vm.item} property="_eventOccurredAtDate">
          <FormLabel>{vm.translateAttribute("eventOccurredAtDate")}</FormLabel>
          <DatePickerBox
            placementOverlay="top-start"
            strategyOverlay="fixed"
            fromMonth={subYears(new Date(), 2)}
            toMonth={endOfCzechDay(new Date())}
            disabledDays={disabledDaysRange(endOfCzechDay(new Date()), subYears(new Date(), 2))}
            placeholder={vm.translateAttribute("eventOccurredAtDatePlaceholder")}
          />
        </FormGroup>
        <FormGroup className="pl-3 pb-1 pt-1" as={Col} md={6} lg={6} xl={6} target={vm.item} property="_eventOccurredAtTime">
          <FormLabel>{vm.translateAttribute("eventOccurredAtTime")}</FormLabel>
          <TimeInput className="mw-100" />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default LustrationReportsForm;
